import React, { useState, useEffect, useRef } from "react";
import "./ScrollToTop.css";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const lastScrollYRef = useRef(0);

  useEffect(() => {
    lastScrollYRef.current = window.pageYOffset; // Initialize with current scroll position

    const handleScroll = () => {
      const currentScrollY = window.pageYOffset;
      const isAtTop = currentScrollY < 10;
      const isScrollingUp = currentScrollY < lastScrollYRef.current;

      let shouldBeVisible;

      if (isAtTop) {
        shouldBeVisible = false; // Hide at the very top
      } else if (isScrollingUp) {
        shouldBeVisible = false; // Hide when scrolling up
      } else {
        // Scrolling down or stationary (and not at the top)
        if (currentScrollY > 300) {
          shouldBeVisible = true; // Show if scrolled past 300px
        } else {
          shouldBeVisible = false; // Hide if below 300px
        }
      }

      setIsVisible(shouldBeVisible);
      lastScrollYRef.current = currentScrollY; // Update last scroll position
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Call once on mount to set initial state based on scroll position

    return () => window.removeEventListener("scroll", handleScroll);
  }, []); // Empty dependency array, logic is self-contained

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`scroll-to-top ${isVisible ? "visible" : ""} ${
        isHovered ? "hovered" : ""
      }`}
      aria-label="Scroll to top"
      aria-hidden={!isVisible}
      style={{ pointerEvents: isVisible ? "auto" : "none" }}
    >
      <span className="scroll-icon">
        <svg
          viewBox="0 0 24 24"
          width="24"
          height="24"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 15l-6-6-6 6"></path>
        </svg>
      </span>
      <span className="scroll-trail"></span>
    </button>
  );
};

export default ScrollToTop;
